import { SET_SAVING, SET_ERROR, SET_CURRENCY, INIT_GROUP_FROM_RELATED, SET_EXCHANGE_RATE } from '@/constants/mutation_types'
import { CURRENCY_USA } from '@/constants/trans'
import { getExchangeRate } from '@/api/groupTour'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    items: {
      baseCurrency: CURRENCY_USA,
      saleCurrency: CURRENCY_USA,
      mcoServiceFee: 0,
      exchangeRate: 0,
      relatedForm: {
        basic_info: {},
        customer_info: {}
      },
      baseObject: {
        payment_method: '',
        base_fare: '',
        currency: CURRENCY_USA
      },
      sellObject: {
        payment_method: '',
        sell_price: '',
        currency: CURRENCY_USA
      }
    },
    saving: false,
    errors: []
  },
  getters: {
    mcoAmount: (state) => state.items.original_fare
  },
  mutations: {
    [SET_SAVING] (state, saving) {
      state.saving = saving
    },
    [SET_ERROR] (state, errors) {
      state.errors = state.errors.concat(errors)
    },
    [SET_CURRENCY] (state, {item, currency}) {
      state.items[`${item}Currency`] = currency
    },
    [INIT_GROUP_FROM_RELATED] (state, relatedForm) {
      state.items.relatedForm.basic_info = {...relatedForm.basic_info}
      state.items.relatedForm.customer_info = {...relatedForm.customer_info}
    },
    [SET_EXCHANGE_RATE] (state, rate) {
      state.items.exchangeRate = rate
    },
    // eslint-disable-next-line
    SET_FARE (state, {originalFare, totalFare}) {
      // eslint-disable-next-line
      state.items.original_fare = originalFare
      // eslint-disable-next-line
      state.items.total_fare = totalFare
    },
    setMcoServiceFee (state, fee) {
      state.items.mcoServiceFee = Number(fee)
    },
    setBaseMethod (state, method) {
      state.items.baseObject.payment_method = method
    },
    setSellMethod (state, method) {
      state.items.sellObject.payment_method = method
    },
    setSellPrice (state, price) {
      state.items.sellObject.sell_price = price
    },
    setBaseFare (state, fare) {
      state.items.baseObject.base_fare = fare
    },
    initUpdatePageInitState (state, paymentInfo) {
      state.items.baseObject.baseCurrency = paymentInfo.base_to_selling[0].base_fare.currency
      state.items.baseObject.base_fare = paymentInfo.base_to_selling[0].base_fare.ori_original_fare
      state.items.sellObject.saleCurrency = paymentInfo.base_to_selling[0].selling_fare.currency
      state.items.sellObject.sell_price = paymentInfo.base_to_selling[0].selling_fare.ori_total_fare
      state.items.mcoServiceFee = paymentInfo.base_to_selling[0].selling_fare.ori_total_fare * paymentInfo.base_to_selling[0].selling_fare.mco_service_fee_ratio
    },
    initFareState (state, sales) {
      let init = {
        baseCurrency: CURRENCY_USA,
        saleCurrency: CURRENCY_USA,
        mcoServiceFee: 0,
        relatedForm: {
          basic_info: {
            sales_username: sales
          },
          customer_info: {}
        },
        baseObject: {
          payment_method: '',
          base_fare: '',
          currency: CURRENCY_USA
        },
        sellObject: {
          payment_method: '',
          sell_price: '',
          currency: CURRENCY_USA
        }
      }
      Vue.set(state, 'items', init)
    }
  },
  actions: {
    setSaving ({ commit }, saving) {
      commit('SET_SAVING', saving)
    },
    setError ({ commit }, errors) {
      commit('SET_ERROR', errors)
    },
    setCurrency ({ commit }, {item, currency}) {
      commit('SET_CURRENCY', {item, currency})
    },
    setExchangeRate ({ commit }, exchangeRate) {
      commit('SET_EXCHANGE_RATE', exchangeRate)
    },
    setMcoServiceFee ({ state, commit }, fee) {
      commit('setMcoServiceFee', fee)
    },
    initFormFromRelated ({ commit }, relatedForm) {
      commit('INIT_GROUP_FROM_RELATED', relatedForm)
    },
    fetchExchange ({ commit }, base) {
      return new Promise((resolve, reject) => {
        getExchangeRate()
          .then(resp => {
            let rate = resp.data.rates['CNY'].toFixed(2)
            if (!rate) {
              reject(new Error(`Can't get rate`))
              rate = 7.00
            }
            commit('SET_EXCHANGE_RATE', rate)
            resolve(rate)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/group.js